import React from 'react'

export const UsdtSvg = ({ className }) => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className}`}
      >
        <g clip-path="url(#clip0_2408_4115)">
          <path
            d="M15.6905 2.82373C15.999 2.82383 16.302 2.90546 16.5687 3.06035C16.8355 3.21524 17.0565 3.43789 17.2095 3.70573L20.1268 8.80873C20.3172 9.14198 20.3927 9.52858 20.3418 9.90899C20.2909 10.2894 20.1164 10.6425 19.845 10.914L11.7224 19.0366C11.6208 19.1382 11.5003 19.2188 11.3675 19.2738C11.2348 19.3288 11.0926 19.3571 10.9489 19.3571C10.8053 19.3571 10.663 19.3288 10.5303 19.2738C10.3976 19.2188 10.277 19.1382 10.1754 19.0366L2.05278 10.914C1.78146 10.6425 1.60691 10.2894 1.55599 9.90899C1.50508 9.52858 1.58064 9.14198 1.77103 8.80873L4.68741 3.70486C4.84044 3.4373 5.06143 3.21491 5.32801 3.06019C5.59459 2.90547 5.89731 2.8239 6.20553 2.82373H15.6905ZM13.573 5.44873H8.32304C8.10002 5.44898 7.88551 5.53437 7.72334 5.68747C7.56117 5.84057 7.46358 6.04981 7.45051 6.27245C7.43744 6.49509 7.50988 6.71431 7.65302 6.88533C7.79616 7.05636 7.9992 7.16627 8.22066 7.19261L8.32304 7.19873H10.073V8.55061C9.40979 8.61186 8.80691 8.74048 8.31954 8.92336C7.97391 9.05286 7.66416 9.21736 7.43316 9.42298C7.20216 9.62773 7.01054 9.91036 7.01054 10.2612C7.01054 10.6121 7.20216 10.8947 7.43316 11.0995C7.66416 11.3051 7.97391 11.4696 8.31954 11.5982C8.83929 11.7934 9.49029 11.9281 10.2069 11.9832C10.1376 12.0935 10.094 12.2179 10.0792 12.3472L10.073 12.4487V14.1987C10.0733 14.4218 10.1587 14.6363 10.3118 14.7984C10.4649 14.9606 10.6741 15.0582 10.8968 15.0713C11.1194 15.0843 11.3386 15.0119 11.5096 14.8687C11.6807 14.7256 11.7906 14.5226 11.8169 14.3011L11.823 14.1987V12.4487C11.8233 12.284 11.7769 12.1226 11.6892 11.9832C12.4058 11.9281 13.0568 11.7942 13.5765 11.5982C13.9222 11.4696 14.2319 11.3051 14.4629 11.0995C14.6939 10.8947 14.8855 10.6121 14.8855 10.2612C14.8855 9.91036 14.6939 9.62773 14.4629 9.42298C14.2319 9.21736 13.9222 9.05286 13.5765 8.92423C13.1005 8.75349 12.6064 8.6384 12.1039 8.58123L11.823 8.55061V7.19873H13.573C13.7961 7.19848 14.0106 7.11309 14.1727 6.95999C14.3349 6.80689 14.4325 6.59765 14.4456 6.37501C14.4586 6.15237 14.3862 5.93315 14.2431 5.76213C14.0999 5.59111 13.8969 5.4812 13.6754 5.45486L13.573 5.44873ZM11.8222 9.42998C12.3157 9.47334 12.8019 9.57828 13.2694 9.74236C13.5573 9.85085 13.7594 9.96898 13.8819 10.0775C13.9351 10.1184 13.9772 10.1719 14.0044 10.2332L14.0105 10.2612L14.0044 10.2892C13.9772 10.3505 13.9351 10.4041 13.8819 10.445C13.7594 10.5535 13.5573 10.6725 13.2694 10.7792C12.6963 10.9945 11.8755 11.1362 10.948 11.1362C10.0205 11.1362 9.19979 10.9945 8.62666 10.7792C8.33879 10.6716 8.13666 10.5535 8.01329 10.445C7.96011 10.4041 7.918 10.3505 7.89078 10.2892L7.88554 10.2612C7.88554 10.2499 7.88991 10.1869 8.01329 10.0775C8.13579 9.96898 8.33879 9.84998 8.62666 9.74323C9.01166 9.59886 9.50779 9.48686 10.0739 9.42998C10.084 9.65505 10.1805 9.86755 10.3433 10.0233C10.5061 10.179 10.7227 10.2659 10.948 10.2659C11.1733 10.2659 11.3899 10.179 11.5528 10.0233C11.7156 9.86755 11.8121 9.65505 11.8222 9.42998Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_2408_4115">
            <rect
              width="21"
              height="21"
              fill="currentColor"
              transform="translate(0.446777 0.19873)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  )
}

export const BusdSvg = ({ className }) => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className}`}
      >
        <g clip-path="url(#clip0_2408_4122)">
          <path
            d="M11.3057 0.19873L4.7959 10.9925L11.3057 14.8383L17.8155 10.9925L11.3057 0.19873ZM11.3057 21.3976L4.7959 12.2264L11.3057 16.0979L17.8155 12.2264L11.3057 21.3976Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_2408_4122">
            <rect
              width="21.1989"
              height="21.1989"
              fill="currentColor"
              transform="translate(0.706055 0.19873)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  )
}

export const ThreeDotsSvg = ({ className }) => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className}`}
      >
        <path
          d="M10.2314 4.98115C10.2314 5.28864 10.3536 5.58353 10.571 5.80095C10.7884 6.01838 11.0833 6.14053 11.3908 6.14053C11.6983 6.14053 11.9932 6.01838 12.2106 5.80095C12.428 5.58353 12.5502 5.28864 12.5502 4.98115C12.5502 4.67367 12.428 4.37878 12.2106 4.16135C11.9932 3.94393 11.6983 3.82178 11.3908 3.82178C11.0833 3.82178 10.7884 3.94393 10.571 4.16135C10.3536 4.37878 10.2314 4.67367 10.2314 4.98115ZM10.2314 10.778C10.2314 11.0855 10.3536 11.3804 10.571 11.5978C10.7884 11.8153 11.0833 11.9374 11.3908 11.9374C11.6983 11.9374 11.9932 11.8153 12.2106 11.5978C12.428 11.3804 12.5502 11.0855 12.5502 10.778C12.5502 10.4705 12.428 10.1757 12.2106 9.95823C11.9932 9.7408 11.6983 9.61865 11.3908 9.61865C11.0833 9.61865 10.7884 9.7408 10.571 9.95823C10.3536 10.1757 10.2314 10.4705 10.2314 10.778ZM10.2314 16.5749C10.2314 16.8824 10.3536 17.1773 10.571 17.3947C10.7884 17.6121 11.0833 17.7343 11.3908 17.7343C11.6983 17.7343 11.9932 17.6121 12.2106 17.3947C12.428 17.1773 12.5502 16.8824 12.5502 16.5749C12.5502 16.2674 12.428 15.9725 12.2106 15.7551C11.9932 15.5377 11.6983 15.4155 11.3908 15.4155C11.0833 15.4155 10.7884 15.5377 10.571 15.7551C10.3536 15.9725 10.2314 16.2674 10.2314 16.5749Z"
          fill="currentColor"
        />
      </svg>
    </>
  )
}

export const RightArrowSvgs = ({ className }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        className={`${className}`}
      >
        <path
          d="M5.2403 11.9448L16.8263 11.9448L12.3263 7.44476L13.7403 6.03076L20.6543 12.9448L13.7403 19.8588L12.3263 18.4448L16.8263 13.9448L5.2403 13.9448L5.2403 11.9448Z"
          fill="currentColor"
        />
      </svg>
    </>
  )
}

// export const Svgs = () => {
//   return (
//     <>

//     </>
//   )
// }
